import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MenuHeader } from '../menu/menuHeader'
import { FeedbackList } from './_components/feedbackList'
import MenuInfo from '../menu/menuInfo'
import { GolfBizNm, GolfInfoData } from '../promotion/promotionItem'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const Feedback: React.FC = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const { isMobile, isTablet, isDesktop } = useResponsive()

  return (
    <>
      <SEO
        title="목소리"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/feedback"
      />
      <div style={{ padding: isMobile ? '0 16px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={true}
          menuInfoRef={menuInfoRef}
          loginRequired={true}
          iconActive={hasMenuInfo}
        />
      </div>
      <FeedbackList />
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
    </>
  )
}
export default Feedback
